import type { oz } from '@weft/utils';
import { created } from '../../utils/created';
import { CustomerSchema } from '../customer';
import { PlanSchema } from '../plan';
import { NewContractSchema } from './new-contract-schema';

export const ContractSchema = created(
  NewContractSchema
    .omit({ customerId: true, planId: true })
    .extend({
      customer: CustomerSchema,
      plan: PlanSchema,
    }),
).openapi('Contract');

export type Contract = oz.infer<typeof ContractSchema>;